import { React, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import UserSVG from "../../assets/SVG/user.svg";
import {
  faEnvelope,
  faMobile,
  faCamera,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useAuth } from "../../context/AuthContext";
import { userUpdate } from "../../services/userFn";
import AppLoader from "../loader/loader";
import { helper } from "../../helper/helper";
import userImage from "../../assets/image/profile.png";

const Updateprofile = () => {
  const { user } = useAuth();
  const { login } = useAuth();
  const [contact, setContact] = useState(user?.contact);
  const [email, setEmail] = useState(user?.email);
  const [isLoading, setIsLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(user?.image);
  const [username, setUserName] = useState(user?.username);
  const navigate = useNavigate();

  const showAlert = (title, text, icon) => {
    Swal.fire({
      title,
      text,
      icon,
      confirmButtonText: "OK",
    });
  };

  const handleImageChange = async (e) => {
    const selectedFile = e.target.files[0];

    setIsLoading(true);
    try {
      const uploadedUrl = await helper.uploadMediaService(selectedFile);
      setImageUrl(uploadedUrl);
      setIsLoading(false);
      showAlert("Image Upload", "Image uploaded successfully!", "success");
    } catch (error) {
      showAlert(error.message);
    }
  };

  const handleSubmit = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email && !emailRegex.test(email)) {
      showAlert("Error", "Please enter a valid email address", "error");
      return;
    }

    if (!contact) {
      showAlert("Error", "Please enter phone number", "error");
      return;
    }

    const payload = {
      contact: contact,
      username: username,
      image: imageUrl,
    };

    try {
      setIsLoading(true);
      const response = await userUpdate(user._id, payload);
      if (response.status === 200 || response.status === 201) {
        const newUserObj = {
          ...user,
          ...response.data.data,
        };
        showAlert("Success", response.data.message, "success");
        navigate("/account");
        login(newUserObj);
      } else {
        showAlert("Error", response.data.message, "error");
      }
    } catch (error) {
      showAlert("Error", error.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AppLoader isVisible={isLoading} />
      <section className="update-section " id="update-section">
        <div className="hero-update">
          <div className="container-update">
            <div className="box-update">
              <h1 className="update-pg">Update Profile</h1>

              <div
                className="col-lg-12 text-center"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div style={{ position: "relative" }}>
                  <input
                    id="file-input"
                    type="file"
                    onChange={handleImageChange}
                    accept="image/*"
                    style={{ display: "none" }}
                  />

                  {imageUrl && (
                    <img
                      src={imageUrl}
                      alt="Uploaded Preview"
                      className="img-control"
                      style={{
                        height: "100px",
                        width: "100px",
                        borderRadius: "100px",
                      }}
                    />
                  )}
                  {!imageUrl && (
                    <img
                      src={userImage}
                      alt="Uploaded Preview"
                      className="img-control"
                      style={{
                        height: "100px",
                        width: "100px",
                        borderRadius: "100px",
                      }}
                    />
                  )}
                  <label
                    htmlFor="file-input"
                    style={{
                      height: "35px",
                      width: "35px",
                      position: "absolute",
                      right: 0,
                      bottom: 0,
                      borderRadius: "10px",
                      backgroundColor: "#FFF",
                      display: "flex",
                      alignItems: "center",
                      border: "3px solid #bc6c25",
                      justifyContent: "center",
                    }}
                  >
                    <FontAwesomeIcon icon={faCamera} color="#bc6c25" />
                  </label>
                </div>
              </div>

              <div className="col-lg-12">
                <div className="input-group">
                  <div className="input-container">
                    <label htmlFor="email" className="input-label">
                      <FontAwesomeIcon icon={faUser} Name="input-icon" />
                      User Name
                    </label>
                    <input
                      value={username}
                      onChange={(e) => setUserName(e.target.value)}
                      type="text"
                      placeholder="User Name"
                      className="input-field"
                    />
                  </div>
                </div>
                <div className="input-group update-profile">
                  <div className="input-container">
                    <label htmlFor="email" className="input-label">
                      <FontAwesomeIcon
                        icon={faEnvelope}
                        className="input-icon"
                      />
                      Email
                    </label>
                    <input
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      type="email"
                      id="email"
                      placeholder="demo@gmail.com"
                      className="input-field"
                    />
                  </div>
                </div>
                <div className="input-group">
                  <div className="input-container">
                    <label htmlFor="email" className="input-label">
                      <FontAwesomeIcon icon={faMobile} className="input-icon" />
                      Phone
                    </label>
                    <input
                      value={contact}
                      onChange={(e) => setContact(e.target.value)}
                      type="tel"
                      id="email"
                      placeholder="XXX-XXX-XXXX"
                      className="input-field"
                    />
                  </div>
                </div>
              </div>

              <div className="col-lg-12 col-md-12 col-sm-12">
                <button className="btn-1" onClick={handleSubmit}>
                  Update Profile
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Updateprofile;
